import React from "react";

import PanelContent from "Components/Panels/PanelContent";
import SwitchInput from "Components/Switch/Input";
import { Field, useFormikContext } from "formik";

export function Attributes() {
  const { values, setFieldValue } = useFormikContext();

  const handleChange = (value, field) => {
    setFieldValue(field, value);
  };

  return (
    <>
      <PanelContent title="Atributos">
        <div className="row">
          <div className="xs-12">
            <Field
              component={SwitchInput}
              label="Próximo ao metrô ou trem"
              id="next_subway"
              onChange={(e) => handleChange(e, "next_subway")}
              value={values.next_subway}
              textOn="Ativo"
              textOff="Inativo"
            />
          </div>
          <div className="xs-12">
            <Field
              component={SwitchInput}
              label="status Unidade"
              id="open_unit"
              onChange={(e) => handleChange(e, "open_unit")}
              value={values.open_unit}
              textOn="Aberto"
              textOff="Fechada"
            />
          </div>
          <div className="xs-12">
            <Field
              component={SwitchInput}
              label="Acessibilidade para cadeirantes"
              id="accessibility"
              onChange={(e) => handleChange(e, "accessibility")}
              value={values.accessibility}
              textOn="Ativo"
              textOff="Inativo"
            />
          </div>
          <div className="xs-12">
            <Field
              component={SwitchInput}
              label="Rampa cadeirante"
              id="wheelchair"
              onChange={(e) => handleChange(e, "wheelchair")}
              value={values.wheelchair}
              textOn="Ativo"
              textOff="Inativo"
            />
          </div>
          <div className="xs-12">
            <Field
              component={SwitchInput}
              label="Estacionamento da Unidade"
              id="parking"
              onChange={(e) => handleChange(e, "parking")}
              value={values.parking}
              textOn="Ativo"
              textOff="Inativo"
            />
            <Field
              component={SwitchInput}
              label="Abre em breve"
              id="coming_soon"
              onChange={(e) => handleChange(e, "coming_soon")}
              value={values.coming_soon}
              textOn="Ativo"
              textOff="Inativo"
            />
            <Field
              component={SwitchInput}
              label="Exame Toxicológico"
              id="toxic_exam"
              onChange={(e) => handleChange(e, "toxic_exam")}
              value={values.toxic_exam}
              textOn="Ativo"
              textOff="Inativo"
            />
            <Field
              component={SwitchInput}
              label="Posto de Coleta"
              id="collection_point"
              onChange={(e) => handleChange(e, "collection_point")}
              value={values.collection_point}
              textOn="Ativo"
              textOff="Inativo"
            />
          </div>
        </div>
      </PanelContent>
    </>
  );
}
